import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatTableDataSource, ThemePalette } from '@angular/material';
import { ToasterService } from 'angular2-toaster';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ErrorDialogComponent } from 'src/app/components/dialog/error-dialog/error-dialog.component';
import { ErrorPadraoDialogComponent } from 'src/app/components/dialog/error-padrao-dialog/error-padrao-dialog.component';
import { MensagemDialogComponent } from 'src/app/components/dialog/mensagem-dialog/mensagem-dialog.component';
import { SuccessDialogComponent } from 'src/app/components/dialog/success-dialog/success-dialog.component';
import { Cr } from 'src/app/components/transferobjects/abertura-chamado/Cr';
import { Banco } from 'src/app/model/banco';
import { FormaSolicitacao } from 'src/app/model/formaSolicitacao';
import { Responsavel } from 'src/app/model/responsavel';
import { Sistema } from 'src/app/model/sistema';
import { SistemaDocumento } from 'src/app/model/sistemaDocumento';
import { SistemaTipoSolicitacao } from 'src/app/model/sistemaTipoSolicitacao';
import { ConsultaCepService } from 'src/app/service/consulta-cep/consulta-cep.service';
import { FormaSolicitacaoService } from 'src/app/service/forma-solicitacao/forma-solicitacao.service';
import { PadraoService } from 'src/app/service/padrao/padrao.service';
import { ResponsavelService } from 'src/app/service/responsavel/responsavel.service';
import { ServentiaService } from 'src/app/service/serventia/serventia.service';
import { SistemaService } from 'src/app/service/sistema/sistema.service';
import { SistemaDocumentoService } from 'src/app/service/sistemaDocumento/sistema-documento.service';
import { TipoSolicitacaoService } from 'src/app/service/tipoSolicitacao/tipo-solicitacao.service';
import { isValidCpf } from 'src/app/utils/shared/cpfValidator';
import { environment } from 'src/environments/environment';
import { AbrirChamadoDTO } from '../../components/transferobjects/abertura-chamado/AbrirChamadoDTO';

@Component({
  selector: 'app-chamado-delegatario-cadastro-acesso',
  templateUrl: './chamado-delegatario-cadastro-acesso.component.html',
  styleUrls: ['./chamado-delegatario-cadastro-acesso.component.css']
})
export class ChamadoDelegatarioCadastroAcessoComponent implements OnInit {

  @BlockUI() loading: NgBlockUI;
  @Input() recebeTipoChamado: any;
  @Output() enviarTipoChamado = new EventEmitter();

  recaptcha: ReCaptchaV3Service;

  valido: boolean;
  registerForm: FormGroup;
  tipoChamadoForm : FormGroup;
  bancoForm: FormGroup;
  submitted = false;

  divCadastroACesso = false;
  divErroFalhaInfo = false;

  validFormaSolicitacao = false;
  mandaTipoChamado : any;

  telMaskEscrevente : string;
  telMaskSubtituto : string;
  telMaskDelegatario: string;
  onLoad = false;

  /* variáveis do "anexo erro" */
  msgNomeAnexoErroAnterior: String;
  msgErroAnexoAnterior: String;
  imgAnexoErro: any;

  /* variáveis do "anexo erro anterior" */
  msgErroAnexo: String;
  msgNomeAnexoErro: String;
  imgAnexoErroAnterior: any;

  responsavelList = new Array<Responsavel>();
  formaSolicitacaoList = new Array<FormaSolicitacao>();
  nomeSistemas = new Array<Sistema>();
  sistemasSelected = new Array<any>();
  grupoSelected = new Array<any>();
  solicitacoesNome = new Array<String>();
  solicitacoesCoarc = new Array<String>();

  listaSistemaDocumento = new Array<SistemaDocumento>();
  
  sistemaTipoSolicitacaoList = new Array<SistemaTipoSolicitacao>();
  nomeServicos = new Array<SistemaTipoSolicitacao>();
  nomeServicosSelected = new Array<any>();

  listaBancos = new Array<Banco>();
  dataSource: MatTableDataSource<Banco>;
  displayedColumns: string[] = ['banco','agencia','conta', 'acoes'];

  nomeAnexoErro: String
  nomeAnexoErroAnterior: String

  chamadoDados: AbrirChamadoDTO;

  chamadoDadosMontado = new Array<AbrirChamadoDTO> ();
  chamadoAberto: String;
  resposta: any;
  valorDialog: any;

  anexos: any[] = [];
  anexosStage: any[] = []; 
  tamanhoPermitido: any = 19999854; //20971520;
  tamanhoLido = 0; 
  map = new Map();

  counter = 1;
  progressBar: any = 0;

  mode: String = 'determinate';
  color: ThemePalette = 'primary';
  value = 0;   // 20000000
  bufferValue = ((20479854 * (0.0000010)) * 5); //20971520

  anexoForm: FormGroup;

  count = 0

 element: HTMLElement;
 inputAnexo: HTMLInputElement;

 extensaoDeAnexo: string;

 arquivo: File;

 valorInput: any;

 nomeBancos: any = [
      { id: 'Banco do Brasil', valor: 'Banco do Brasil' },
      { id: 'Bradesco', valor: 'Bradesco' },
      { id: 'Caixa Econômica Federal', valor: 'Caixa Econômica Federal' }
  ];

  constructor(
              private formBuilder: FormBuilder, 
              private padraoService: PadraoService, 
              private dialog: MatDialog, 
              private toast: ToasterService,
              private formaSolicitacaoService: FormaSolicitacaoService,
              private responsavelService: ResponsavelService,
              private sistemaService: SistemaService,
              private tipoSolicitacaoService : TipoSolicitacaoService,
              private sistemaDocumentoService : SistemaDocumentoService,
              private serventiaService : ServentiaService,
              private consultaCepService :ConsultaCepService
              ) { }
  ngAfterViewInit() { }

  ngOnInit() {
    this.chamadoDados = new AbrirChamadoDTO();
    this.chamadoDadosMontado = new Array<AbrirChamadoDTO> ();
    this.listaSistemaDocumento = new Array<SistemaDocumento>();
    this.sistemaTipoSolicitacaoList = new Array<SistemaTipoSolicitacao>();
    this.nomeServicos = new Array<SistemaTipoSolicitacao>();
    this.nomeServicosSelected = new Array<any>();
    this.sistemasSelected = new Array<any>();
    
    this.listaBancos = new Array<Banco>();

    this.anexoForm = this.formBuilder.group({ anexoItem: [] });

    this.tipoChamadoForm = this.formBuilder.group({ tipoChamado:["", Validators.required]});

    this.registerForm = this.formBuilder.group({
      responsavel: ["", Validators.required],  
      nomeSistema: ["", Validators.required],  
      nomeServico: ["", Validators.required],  
      detalhe: ["", [Validators.required, Validators.minLength(25)]],
      nomeCompletoDelegatario: ["", [Validators.required,Validators.minLength(4), Validators.maxLength(100)]],      
      numeroCpfDelegatario: ['', Validators.compose([Validators.required, Validators.minLength(11), isValidCpf()])],
      emailDelegatario: ['', [Validators.required, Validators.email]],
      numeroTelefoneDelegatario: ["", [Validators.required, Validators.minLength(10)]],
      nomeCompletoSubstituto: ["", [Validators.maxLength(100)]],      
      numeroCpfSubstituto: ['', Validators.compose([ Validators.minLength(11), isValidCpf()])],
      emailSubstituto: ['', [Validators.required, Validators.email]],
      numeroTelefoneSubstituto: ["", [Validators.minLength(10)]],
      nomeCompletoEscrevente: ["", [Validators.maxLength(100)]],      
      numeroCpfEscrevente: ['', Validators.compose([ Validators.minLength(11), isValidCpf()])],
      emailEscrevente: ['', [Validators.required, Validators.email]],
      numeroTelefoneEscrevente: ["", [Validators.minLength(10)]],
      codigoCNSArecadacao : ["", [Validators.required]],
      cnpj: ['', Validators.compose([ Validators.minLength(14),Validators.required])],
      municipio:[""],
      sigla:[""],
      denominacao:[""],
      distrito:[""],
      status:[""],
      cep: [""],
      logradouro: [""],
      bairro: [""],
      enderecoNumero: [""],
      enderecoMunicipio: [""],
      enderecoComarca: [""],
      cepSubstituto: [""],
      logradouroSubstituto: [""],
      bairroSubstituto: [""],
      enderecoNumeroSubstituto: [""],
      enderecoMunicipioSubstituto: [""],
      enderecoComarcaSubstituto: [""],
      codigoFlag: [""],
      codigoCEI: [""],
      codigoGerencia: [""],
      codigoIBGE: [""]
    });

    this.bancoForm = this.formBuilder.group({
      banco: ["", Validators.required],  
      agencia: ["", Validators.required],  
      conta: ["", [Validators.required]]
    });

    this.registerForm.get('numeroTelefoneDelegatario').valueChanges.map(valor => valor.length).subscribe(length => {
      if (length < 11) {
        this.telMaskDelegatario = '(00) 0000-00000'
      }
      else {
        this.telMaskDelegatario = '(00) 00000-0000'
      }
    });

    this.registerForm.get('numeroTelefoneSubstituto').valueChanges.map(valor => valor.length).subscribe(length => {
      if (length < 11) {
        this.telMaskSubtituto = '(00) 0000-00000'
      }
      else {
        this.telMaskSubtituto = '(00) 00000-0000'
      }
    });

    this.registerForm.get('numeroTelefoneEscrevente').valueChanges.map(valor => valor.length).subscribe(length => {
      if (length < 11) {
        this.telMaskEscrevente = '(00) 0000-00000'
      }
      else {
        this.telMaskEscrevente = '(00) 00000-0000'
      }
    });
    
    this.registerForm.get('emailDelegatario').valueChanges.subscribe(event => {
      this.registerForm.get('emailDelegatario').setValue(event.toLowerCase(), {emitEvent: false});
   });

   this.registerForm.get('emailSubstituto').valueChanges.subscribe(event => {
    this.registerForm.get('emailSubstituto').setValue(event.toLowerCase(), {emitEvent: false});
    });

    this.carregarFormaSolicitacao();
    this.carregarListResponsavel();
    
  }

  resetForm() {
    console.log('Entrou');
    this.enviarTipoChamado.emit('OI');
  }


  limparTipoChamado(value) {
    this.limparForm();
  }

  carregarListResponsavel(): void {
    this.loading.start('Aguarde um momento...');
    this.responsavelService.obterListaResponsavel().subscribe(response => {
      this.responsavelList = response;
      this.loading.stop();
    }, (error) => {
      this.loading.stop();
      this.abrirRespostaErro(error);
    });
  }

 
  carregarFormaSolicitacao(): void {
    this.loading.start('Aguarde um momento...');
    this.formaSolicitacaoService.obterListaFormaSolicitacao().subscribe(response => {
      this.formaSolicitacaoList = response;
      this.loading.stop();
    }, (error) => {
      this.loading.stop();
      this.abrirRespostaErro(error);
    });
  }

  

  carregarSistemas(): void {
    
    this.limparCombo();
    this.loading.start('Aguarde um momento...');
    this.sistemaService.obterListaSistemas().subscribe(response => {
      this.nomeSistemas = response;
      this.loading.stop();
    }, (error) => {
      this.loading.stop();
      this.abrirRespostaErro(error);
    });
  }

  carregarDivGrids(solicitacao:any) {
    this.validFormaSolicitacao = true;
    var tipoChamado = solicitacao.descricao 
    this.mandaTipoChamado = solicitacao.descricao; 
    if(tipoChamado ==="CADASTRO / Acesso") {
      this.divCadastroACesso = true; 
      this.divErroFalhaInfo = false;
      
    }else{
      this.divCadastroACesso = false;
      this.divErroFalhaInfo = true;
    }
  }


  carregarTiposDoServico(event) {

    if (this.registerForm.get('responsavel').value) {
            if (event.isUserInput) {
                if(event.source._selected){
                  this.sistemasSelected.push(event.source.value);
                }else{
                  var index = this.sistemasSelected.indexOf(event.source.value);
                  if (index > -1) {
                    this.sistemasSelected.splice(index, 1);
                  }  
                }

                this.isValidBanco();
                this.isNomeSistemasSCC();
                
                this.loading.start('Aguarde um momento...');
                if(this.sistemasSelected.length > 0 ) {

                  var responsavel = this.registerForm.get('responsavel').value

                  this.sistemaTipoSolicitacaoList = new Array<SistemaTipoSolicitacao>();
                  this.nomeServicos = new Array<SistemaTipoSolicitacao>();
                  this.tipoSolicitacaoService.obterListaSisemaTipoSolicitacao(this.sistemasSelected,responsavel).subscribe(response => {
                    this.sistemaTipoSolicitacaoList = response;
                    this.nomeServicos = new Array<SistemaTipoSolicitacao>();
                    this.nomeServicosSelected = new Array<any>();
                    this.registerForm.controls['nomeServico'].setValue('');

                    this.sistemaTipoSolicitacaoList.forEach(tp =>{
                      this.nomeServicos.push(tp);              
                    });
                    
                    this.carregarViaSistemaDocumnetosAnexos();
                    this.loading.stop();
                  }, (error) => {
                    this.loading.stop();
                    this.abrirRespostaErro(error);
                  });
                }else {
                  this.nomeServicosSelected =[];
                  this.nomeServicos = [];
                  this.loading.stop();
                }
            }
    }else {
      console.log(event.source);
      console.log(event);
      event._selected = false;
      event.source.value = '';
      this.registerForm.get('nomeSistema').setValue('');
      this.abrirMensaagemdialog("Responsável é campo obrigatório !","Validação de Formulário","Responsável");
    }
    
  }

  carregarDocumnetosAnexos(event) {

    if (event.isUserInput) {
      if(event.source._selected){
        this.nomeServicosSelected.push(event.source.value);
      }else{
        var index = this.nomeServicosSelected.indexOf(event.source.value);
        if (index > -1) {
          this.nomeServicosSelected.splice(index, 1);
        }  
      } 
      
      this.isValidCampoSubstituto();
      this.isValidCampoEscrevente();
      this.loading.start('Aguarde um momento...');

      this.removeInputAll();

      if(this.sistemasSelected.length > 0 && this.nomeServicosSelected.length > 0 ) {

        var tipoSolicitacao = new Array<any>();

        this.nomeServicosSelected.forEach(id=>{
          this.nomeServicos.forEach(element => {
            if ( element.idSistemaTipoSolicitacao === id ) {
              tipoSolicitacao.push(element.tipoSolicitacao.idTipoSolicitacao);
            }
          });
        });  


          this.sistemaDocumentoService.obterListaDocumentos(this.sistemasSelected,tipoSolicitacao).subscribe(response => {
            this.listaSistemaDocumento = new Array<SistemaDocumento>();

            this.listaSistemaDocumento = response;
           
            this.anexoForm = this.formBuilder.group({
              anexoItem: this.formBuilder.array([this.criarMaisUmCampoAnexo()])
            });

            this.listaSistemaDocumento.forEach(element => {
                var descricao;
                if(element.obrigatorio){
                  descricao = element.documento.descricao + ">> CAMPO OBRIGATÓRIO *";
                }else{
                  descricao = element.documento.descricao;
                }
                 
                this.adicionarUmAnexo(descricao,element.obrigatorio,element.documento.nome);
            });

            this.isValidEnderecoServentia();
            this.loading.stop();
          }, (error) => {
            this.loading.stop();
            this.abrirRespostaErro(error);
          });
      }else {
        this.loading.stop();
      }     
    }
  }

  carregarViaSistemaDocumnetosAnexos() {
      
      this.isValidCampoSubstituto();
      this.isValidCampoEscrevente();
      this.loading.start('Aguarde um momento...');

      this.removeInputAll();

      if(this.sistemasSelected.length > 0 && this.nomeServicosSelected.length > 0 ) {

        var tipoSolicitacao = new Array<any>();

        this.nomeServicosSelected.forEach(id=>{
          this.nomeServicos.forEach(element => {
            if ( element.idSistemaTipoSolicitacao === id ) {
              tipoSolicitacao.push(element.tipoSolicitacao.idTipoSolicitacao);
            }
          });
        });  

          this.sistemaDocumentoService.obterListaDocumentos(this.sistemasSelected,tipoSolicitacao).subscribe(response => {
            this.listaSistemaDocumento = new Array<SistemaDocumento>();

            this.listaSistemaDocumento = response;
           
            this.anexoForm = this.formBuilder.group({
              anexoItem: this.formBuilder.array([this.criarMaisUmCampoAnexo()])
            });

            this.listaSistemaDocumento.forEach(element => {
                var descricao;
                if(element.obrigatorio){
                  descricao = element.documento.descricao + ">> CAMPO OBRIGATÓRIO *";
                }else{
                  descricao = element.documento.descricao;
                }              
                this.adicionarUmAnexo(descricao,element.obrigatorio,element.documento.nome);
            });
            this.loading.stop();
          }, (error) => {
            this.loading.stop();
            this.abrirRespostaErro(error);
          });
      }else {
        this.loading.stop();
      }     
  }

  carregarServentia(cns):void {
    var codigoCns = 0;
    var codigoArrecadacao = 0
    
    if(cns.value.codigoCNSArecadacao === '') {
      this.abrirMensaagemdialog("Insira um valor do CNS/ARRECADAÇÃO para realizar a consulta!","Validação de Formulário","Identificação de Serventia");
      return;
    }

    if (cns.value.codigoFlag == 'ARRECADACAO') {
        codigoCns = 0;
        codigoArrecadacao = cns.value.codigoCNSArecadacao;
    }else if (cns.value.codigoFlag == 'CNS') {
        codigoCns = cns.value.codigoCNSArecadacao;
        codigoArrecadacao = 0;
    }
    else {
      cns.value.codigoCNSArecadacao = '';
      this.abrirMensaagemdialog("Selecione o tipo de Consulta CNS ou Arrecadação!","Validação de Formulário","Identificação de Serventia");
      
      return;
    }

    this.loading.start('Aguarde um momento...');

    this.serventiaService.obterServentia(codigoCns,codigoArrecadacao).subscribe(response => {

      if(response != null && response.length > 0 ) {
        this.registerForm.get('sigla').setValue(response[0].sigla);
        this.registerForm.get('municipio').setValue(response[0].municipio);
        this.registerForm.get('denominacao').setValue(response[0].denominacao);
        this.registerForm.get('status').setValue(response[0].status);
        this.registerForm.get('cnpj').setValue(response[0].cnpj);
        this.registerForm.get('distrito').setValue(response[0].distrito);
      }else{
        this.registerForm.get('codigoCNSArecadacao').setValue('');
        this.registerForm.get('sigla').setValue('');
        this.registerForm.get('municipio').setValue('');
        this.registerForm.get('denominacao').setValue('');
        this.registerForm.get('status').setValue('');
        this.registerForm.get('cnpj').setValue('');
        this.registerForm.get('distrito').setValue('');
        this.abrirMensaagemdialog("Código não encontrado !","Validação de Formulário","Identificação de Serventia");
      }
      this.loading.stop();
    }, (error) => {
      this.loading.stop();
      this.abrirRespostaErroPadrao(error.message);
    });
  }

  carregarEndereco(form,tipo):void {
console.log('FG')
    console.log(form);
    var cep;
    if(tipo ==='SUBSTITUTO') {
      cep = form.value.cepSubstituto;
    }else{
      cep = form.value.cep;
    }
        
    if(cep === '') {
      this.abrirMensaagemdialog("Insira um CEP para realizar a consulta!","Validação de Formulário","Endereço");
      return;
    }

    this.loading.start('Aguarde um momento...');
    this.consultaCepService.obterEndereco(cep).subscribe(response => {

      if(response != null && response.cep != null ) {


        if(tipo ==='SUBSTITUTO') {
          this.registerForm.get('logradouroSubstituto').setValue(response.logradouro);
          this.registerForm.get('enderecoMunicipioSubstituto').setValue(response.localidade);
          this.registerForm.get('bairroSubstituto').setValue(response.bairro);
        }else{
          this.registerForm.get('logradouro').setValue(response.logradouro);
          this.registerForm.get('enderecoMunicipio').setValue(response.localidade);
          this.registerForm.get('bairro').setValue(response.bairro);
        }



          
      }else{

        if(tipo ==='SUBSTITUTO') {
          this.abrirMensaagemdialog("CEP: "+ cep + " não encontrado. Favor verificar!","Validação de Formulário","Endereço");
          this.registerForm.get('cepSubstituto').setValue('');
          this.registerForm.get('logradouroSubstituto').setValue('');
          this.registerForm.get('enderecoMunicipioSubstituto').setValue('');
          this.registerForm.get('bairroSubstituto').setValue('');

        }else{
          this.abrirMensaagemdialog("CEP: "+ cep + " não encontrado. Favor verificar!","Validação de Formulário","Endereço");
          this.registerForm.get('cep').setValue('');
          this.registerForm.get('logradouro').setValue('');
          this.registerForm.get('enderecoMunicipio').setValue('');
          this.registerForm.get('bairro').setValue('');
        }
          
      }
      this.loading.stop();
    }, (error) => { 
      this.loading.stop();
      this.abrirMensaagemdialog("CEP: "+ cep + " não encontrado. Favor verificar!","Validação de Formulário","Endereço");
          this.registerForm.get('cep').setValue('');
          this.registerForm.get('logradouro').setValue('');
          this.registerForm.get('enderecoMunicipio').setValue('');
          this.registerForm.get('bairro').setValue('');
    });
  }

  /* início evento para pegar o endereço do arquivo anexado em - tela erro */
  eventoAnexoErro(event: any): void {
    this.lerEventoErro(event.target);
  }

  lerEventoErro(inputValue: any): void {
    var anexoErro: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.imgAnexoErro = myReader.result;
      this.nomeAnexoErro = anexoErro.name;
    }

    if (anexoErro.name.length > 50) {
      this.msgErroAnexo = 'Nome do arquivo muito extenso';
      this.msgNomeAnexoErro = '';
    }
    else if (anexoErro.size > 2253174) {
      this.msgErroAnexo = 'Tamanho máximo do arquivo foi excedido.';
      this.msgNomeAnexoErro = '';
    }
    else {
      this.msgNomeAnexoErro = anexoErro.name;
      this.msgErroAnexo = '';
      myReader.readAsDataURL(anexoErro);
    }
  }

  /* início evento para pegar  o endereço do arquivo anexado em - tela anterior ao erro */
  eventoAnexoErroAnterior(event: any): void {
    this.lerEventoErroAnterior(event.target);
  }

  lerEventoErroAnterior(inputValue: any): void {
    var anexoErroAnterior: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.imgAnexoErroAnterior = myReader.result;
      this.nomeAnexoErroAnterior = anexoErroAnterior.name;
    }

    if (anexoErroAnterior.size > 2253174) {
      this.msgErroAnexoAnterior = 'Tamanho máximo do arquivo foi excedido.';
      this.msgNomeAnexoErroAnterior = '';
    } else {
      this.msgNomeAnexoErroAnterior = anexoErroAnterior.name;
      this.msgErroAnexoAnterior = '';
      myReader.readAsDataURL(anexoErroAnterior);
    }
  }

  eventoAdicionarAnexo(): any {
     if(this.count === 0) {
     //this.adicionarUmAnexo();
     this.count -= 1;
   } 
   return this.count;
 }

 /* início evento para pegar o endereço do arquivo anexado em - tela erro */

 eventoLeituraArquivo(event: any, id: any, nomeArquivo:string): any {

  this.lerArquivo(event.target, id, nomeArquivo);
   return this.arquivo;
 }


 renomearAquivo(arquivo:File, nomeArquivo: string) : File {
   var file : File;

   var nome = arquivo.name.split('.')[0];
   var extensao = arquivo.name.split('.')[1];
   var nameNovo = nomeArquivo +"."+ extensao;

   file = new File([arquivo],nameNovo,{
    type:arquivo.type, lastModified : arquivo.lastModified
   });

   return file;
 }

 /* Ler o aquivo anexado */
 lerArquivo(anexo: any, id: any , nomeArq: string) {

  var fileRenomeado : File = this.renomearAquivo(anexo.files[0], nomeArq);
         
  const anexoExtensao: File = anexo.files[0];
  this.map.set('divAnexo'+id, fileRenomeado);
  const extensoesNaoPermitidas = ['.exe', '.msi', '.zip', '.rar'];
  let nomeArquivo: string;
  nomeArquivo = fileRenomeado.name.toLowerCase();

  this.valorInput = (document.getElementById('valorAnexo'+id));
  this.valorInput.innerHTML = nomeArquivo;    
  this.tamanhoLido += fileRenomeado.size; 
  this.extensaoDeAnexo = nomeArquivo.substr(nomeArquivo.lastIndexOf('.'));
  
  if (extensoesNaoPermitidas.indexOf(this.extensaoDeAnexo) < 0) {
    if (this.tamanhoLido <  this.tamanhoPermitido) {
      this.msgNomeAnexoErroAnterior = nomeArquivo;
      this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
      this.inputAnexo = (document.getElementById('anexoInput'+id) as HTMLInputElement);
      this.inputAnexo.disabled = true;
    } else {
      this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
      this.limparInput('divAnexo'+id, anexo, id);
      this.toast.pop('warning', 'Soma total de arquivos excedida.');
    }
  }  else {
    this.toast.pop('warning', 'Extensão de arquivo não permitida');
    if(this.count===0) {
      //this.removeInput('divAnexo'+id, anexo);
      this.limparInput('divAnexo'+id, anexo, id);
      //this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
  } else if (this.count > 0) {
     //this.removeInput('divAnexo'+id, anexo); 
      //this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
      this.limparInput('divAnexo'+id, anexo, id);
    }
  }
 }

  get f() {

    return this.registerForm.controls;
  }

  get bancoFormError() {
    return this.bancoForm.controls;
  }

  limparCombo() {
    this.nomeSistemas = new Array<Sistema>();
    this.sistemasSelected = new Array<any>();
    this.registerForm.get('nomeSistema').setValue('');
    this.sistemaTipoSolicitacaoList = new Array<SistemaTipoSolicitacao>();
    this.nomeServicos = new Array<SistemaTipoSolicitacao>();
    this.nomeServicosSelected = new Array<any>();
    this.registerForm.get('nomeServico').setValue('');
    this.removeInputAll();
  }


  limparForm() {
   
    this.limparCombo();

    this.registerForm.get('responsavel').setValue('');
    this.progressBar = 0;
    this.tamanhoLido = 0;
    this.count = 0;
    this.counter = 1;
    this.anexos = [];
    this.tipoChamadoForm.get('tipoChamado').setValue('');
    this.validFormaSolicitacao = false;
    this.divCadastroACesso = false;
    this.divErroFalhaInfo = false;
    this.ngOnInit();
  }

  obterGrupoSistemas() {
    var grupos = [];
    this.sistemasSelected.forEach(idSelecionedo => {
      (this.nomeSistemas.filter(sistema => {
        if( sistema.idSistema === idSelecionedo){
          if(grupos.indexOf(sistema.grupo) < 0){
            grupos.push(sistema.grupo);
          }
        }
      }));
  });
    return grupos;
  }

  obterNomeSistemas(grupo) {
    let nome="";
    this.sistemasSelected.forEach(id => {
          this.nomeSistemas.filter(sistema => {
              if( sistema.idSistema === id && sistema.grupo === grupo ){
                nome +="," + sistema.descricao;
              }
          });
    });
    return nome.substring(1, nome.length);
  }

  nomeSistemasSelecionado() {
    let nome="";
    this.sistemasSelected.forEach(id => {
          this.nomeSistemas.filter(sistema => {
              if( sistema.idSistema === id){
                nome +="," + sistema.descricao;
              }
          });
    });
    return nome.substring(1, nome.length);
  }

  obterNomeSistemasUsuarioIntegracao(): string {
    let nome="";
    this.sistemasSelected.forEach(id => {
          this.nomeSistemas.filter(sistema => {
              if( sistema.idSistema === id && sistema.descricao === "Usuário de integração" ){
                nome  = sistema.descricao;
              }
          });
    });
    return nome;
  }


  obterNomeGrupoSistemas(idCategoria) {
    this.grupoSelected = [];
    let nome="";
    this.sistemasSelected.forEach(id => {
      (this.nomeSistemas.filter(e => {
        if( e.idSistema === id && e.idCategoria === idCategoria){
          nome +="," + e.descricao;
          if(this.grupoSelected.indexOf(e.grupo) < 0){
            this.grupoSelected.push(e.grupo);
          }
        }
      }));
  });

    return this.grupoSelected[0];
  }

  carregarSolicitacoesporGrupo() {
    this.solicitacoesNome = new Array<String>();
    this.solicitacoesCoarc = new Array<String>();
    var lista = [];
    this.nomeServicosSelected.forEach(id => {
      (this.sistemaTipoSolicitacaoList .filter(sistemaTpSoli => {
        if( sistemaTpSoli.idSistemaTipoSolicitacao === id
            && lista.indexOf(sistemaTpSoli) < 0) {
              lista.push(sistemaTpSoli);
              var  nome = sistemaTpSoli.tipoSolicitacao.descricao + " (" + sistemaTpSoli.sistema.descricao + ")"
              
              console.log(sistemaTpSoli.sistema.grupo);
              if(sistemaTpSoli.sistema.grupo === 'COARC_EXTRAJUDICIAL') {
                this.solicitacoesCoarc.push(nome);
              }else {
                this.solicitacoesNome.push(nome);
              }  
        }
      }));
  });
}


  obterNometipoSolicitacao(grupo) {
    let nometipoSolicitacao ="";
    var lista = [];
    this.nomeServicosSelected.forEach(id => {
      (this.sistemaTipoSolicitacaoList .filter(sistemaTpSoli => {
        if( sistemaTpSoli.idSistemaTipoSolicitacao === id
            && sistemaTpSoli.sistema.grupo === grupo && lista.indexOf(sistemaTpSoli) < 0) {
              lista.push(sistemaTpSoli);
              var  nome = sistemaTpSoli.tipoSolicitacao.descricao + " (" + sistemaTpSoli.sistema.descricao + ")"
              nometipoSolicitacao +=", " + nome;  
        }
      }));
  });

  return nometipoSolicitacao.substring(1, nometipoSolicitacao.length);
}

  obterNomeBanco() {
    let nomeBanco = "";
    this.listaBancos.forEach( banco => {
      nomeBanco += banco.banco +", Agência: " + banco.agencia +" , Conta: " + banco.conta + "\n\n || "
    });
    return nomeBanco;
  }

  montarChamado(grupo:any): AbrirChamadoDTO {
    let mChamado = new AbrirChamadoDTO();
    mChamado.cr =  new Cr(); 

   if(grupo === 'COARC_EXTRAJUDICIAL') {
      mChamado.cr.category.id = environment.idcategoriaDelegatarioCoarcExtrajudicial; //'419160',
      mChamado.grupo = 'COARC_EXTRAJUDICIAL';
      mChamado.sistemaUsuarioInt = this.obterNomeSistemasUsuarioIntegracao(); 
   }else{
      mChamado.cr.category.id = environment.idcategoriaDelegatarioNucleoExtrajudicial; //'419161';
      mChamado.grupo = 'NUCLEO_EXTRAJUDICIAL';
   } 
     
    mChamado.cr.customer.name = '';
    mChamado.cr.description = '\n\nDADOS DA SOLICITAÇÃO DE ABERTURA DE CHAMADO - Delegatário'
      + '\n\n --> - DESCRIÇÃO: ' 
      + '\n\n ----->> ' + this.registerForm.controls.detalhe.value
      + '\n' 
      + '\n\n --> - DETALHES SOBRE O CHAMADO:'
      + '\n\n ----->> ' + 'Nome do Sistema: ' + this.obterNomeSistemas(grupo)
      + '\n\n ----->> ' + 'Tipo de Solicitação: ' + this.obterNometipoSolicitacao(grupo)
      + '\n\n --> - IDENTIFICAÇÃO DO DELEGATÁRIO:'
      + '\n\n ----->> ' + 'Responsável: ' + this.registerForm.controls.responsavel.value
      + '\n\n ----->> ' + 'Nome completo: ' + this.registerForm.controls.nomeCompletoDelegatario.value
      + '\n\n ----->> ' + 'CPF: ' + this.registerForm.controls.numeroCpfDelegatario.value
      + '\n\n ----->> ' + 'Email: ' + this.registerForm.controls.emailDelegatario.value
      + '\n\n ----->> ' + 'Telefone: ' + this.registerForm.controls.numeroTelefoneDelegatario.value
      + '\n\n '
      
      if(this.registerForm.controls.nomeCompletoSubstituto.value != null &&
        this.registerForm.controls.nomeCompletoSubstituto.value != undefined &&
        this.registerForm.controls.nomeCompletoSubstituto.value.length > 0){

        mChamado.cr.description = mChamado.cr.description + '--> - IDENTIFICAÇÃO DO SUBSTITUTO:' 
        + '\n\n ----->> ' + 'Nome completo: ' + this.registerForm.controls.nomeCompletoSubstituto.value
        + '\n\n ----->> ' + 'CPF: ' + this.registerForm.controls.numeroCpfSubstituto.value
        + '\n\n ----->> ' + 'Email: ' + this.registerForm.controls.emailSubstituto.value
        + '\n\n ----->> ' + 'Telefone: ' + this.registerForm.controls.numeroTelefoneSubstituto.value
        + '\n\n'
      }

      if(this.registerForm.controls.cepSubstituto.value != null && 
        this.registerForm.controls.cepSubstituto.value != "") {
        
        mChamado.cr.description = mChamado.cr.description + '--> - ENDEREÇO DO SUBSTITUTO:'
        + '\n\n ----->> ' + 'CEP: ' + this.registerForm.controls.cepSubstituto.value
        + '\n\n ----->> ' + 'Logradouro: ' + this.registerForm.controls.logradouroSubstituto.value
        + '\n\n ----->> ' + 'Bairro: ' + this.registerForm.controls.bairroSubstituto.value 
        + '\n\n ----->> ' + 'Número: ' + this.registerForm.controls.enderecoNumeroSubstituto.value
        + '\n\n ----->> ' + 'Município: ' + this.registerForm.controls.enderecoMunicipioSubstituto.value
        + '\n\n ----->> ' + 'Comarca: ' + this.registerForm.controls.enderecoComarcaSubstituto.value
        + '\n\n'
      }
      
      if(this.registerForm.controls.nomeCompletoEscrevente.value != null &&
        this.registerForm.controls.nomeCompletoEscrevente.value != undefined &&
        this.registerForm.controls.nomeCompletoEscrevente.value.length > 0) {

        mChamado.cr.description = mChamado.cr.description + '--> - IDENTIFICAÇÃO DO ESCREVENTE:'
        + '\n\n ----->> ' + 'Nome completo: ' + this.registerForm.controls.nomeCompletoEscrevente.value
        + '\n\n ----->> ' + 'CPF: ' + this.registerForm.controls.numeroCpfEscrevente.value
        + '\n\n ----->> ' + 'Email: ' + this.registerForm.controls.emailEscrevente.value
        + '\n\n ----->> ' + 'Telefone: ' + this.registerForm.controls.numeroTelefoneEscrevente.value
        + '\n\n'
      }
      
      mChamado.cr.description = mChamado.cr.description + '\n\n --> - IDENTIFICAÇÃO DA SERVENTIA:'
      + '\n\n ----->> ' + 'CNS/ARRECADAÇÃO: ' + this.registerForm.controls.codigoCNSArecadacao.value
      + '\n\n ----->> ' + 'Município: ' + this.registerForm.controls.municipio.value
      + '\n\n ----->> ' + 'Sigla: ' + this.registerForm.controls.sigla.value
      + '\n\n ----->> ' + 'Denominação: ' + this.registerForm.controls.denominacao.value
      + '\n\n'

      if(this.registerForm.controls.cep.value != null && this.registerForm.controls.cep.value != "") {

        mChamado.cr.description = mChamado.cr.description + '\n\n --> - ENDEREÇO DA SERVENTIA:'
        + '\n\n ----->> ' + 'CEP: ' + this.registerForm.controls.cep.value
        + '\n\n ----->> ' + 'Logradouro: ' + this.registerForm.controls.logradouro.value
        + '\n\n ----->> ' + 'Bairro: ' + this.registerForm.controls.bairro.value 
        + '\n\n ----->> ' + 'Número: ' + this.registerForm.controls.enderecoNumero.value
        + '\n\n ----->> ' + 'Município: ' + this.registerForm.controls.enderecoMunicipio.value
        + '\n\n ----->> ' + 'Comarca: ' + this.registerForm.controls.enderecoComarca.value
      }
      
      
      if(this.registerForm.controls.codigoCEI.value != null && this.registerForm.controls.codigoCEI.value != ""
      && this.registerForm.controls.codigoCEI.value != undefined) {
        mChamado.cr.description = mChamado.cr.description + '\n\n --> - DADOS:'
        + '\n\n ----->> ' + 'Código CEI: ' + this.registerForm.controls.codigoCEI.value
        + '\n\n ----->> ' + 'Código Gerência: ' + this.registerForm.controls.codigoGerencia.value
        + '\n\n ----->> ' + 'Código IBGE: ' + this.registerForm.controls.codigoIBGE.value 
      }
      
      if(this.listaBancos.length > 0 ){
        mChamado.cr.description = mChamado.cr.description + '\n\n --> - CONTAS BANCÁRIAS:'
        + '\n\n ----->> ' + this.obterNomeBanco()
      }
      
      mChamado.cr.description = mChamado.cr.description + '\n\n';

      if(this.solicitacoesNome.length > 0) {
        mChamado.solicitacoes = this.solicitacoesNome;
      }

      if(this.solicitacoesCoarc.length > 0) { 
        mChamado.solicitacoesCoarc = this.solicitacoesCoarc;
      }
      mChamado.cr.type.REL_ATTR = '';
      mChamado.cr.z_alt_phone_number = this.registerForm.controls.numeroTelefoneDelegatario.value;
      mChamado.cr.cidade.id = '';
      mChamado.cr.lotacao.id = '';
      mChamado.cr.zs_email_preferencial = this.registerForm.controls.emailDelegatario.value;
      mChamado.cr.group.name = grupo; //'COATE_SD_N1';
      mChamado.email = this.registerForm.controls.emailDelegatario.value;
      mChamado.codigoCNSArecadacao = this.registerForm.controls.codigoCNSArecadacao.value;
      mChamado.codigoFlag = this.registerForm.controls.codigoFlag.value;
      mChamado.nomeDelegatario = this.registerForm.controls.nomeCompletoDelegatario.value;
      mChamado.solicitacoes = this.solicitacoesNome;
      mChamado.solicitacoesCoarc = this.solicitacoesCoarc;
    return mChamado;
  }

  abrir() {

    if(!this.isValidarCpfSubstitutoEscrevente()) {
        return false;
    }

    if((this.validarDocumentoObrigatorios() || !this.registerForm.valid)){
      return false;
    }else {

    this.chamadoDadosMontado = new Array<AbrirChamadoDTO> ();

    let grupos  = this.obterGrupoSistemas();

    this.carregarSolicitacoesporGrupo();

    grupos.forEach(grupo => {
        let chamaado = new AbrirChamadoDTO();  
        chamaado = this.montarChamado(grupo);

        if(grupos.length > 1){
          if(chamaado.grupo === 'COARC_EXTRAJUDICIAL'){
            this.chamadoDadosMontado[0] = chamaado;
          }else{
            this.chamadoDadosMontado[1] = chamaado; 
          }
        }else{
          this.chamadoDadosMontado.push(chamaado); 
        }
    });

    var anexos2 = [];
    for (let i = 0; i <= this.map.size; i++) {
      var arquivo = this.map.get('divAnexo' + i);
      
      if(arquivo != undefined) {
        anexos2.push(this.map.get('divAnexo' + i));
      } 
     }

     this.loading.start('Aguarde um momento...');

     if(this.chamadoDadosMontado.length > 1 ) { 
      console.log(this.chamadoDadosMontado);
           
            this.padraoService.abrirChamadoList(this.chamadoDadosMontado, anexos2).subscribe(response => {
              this.chamadoAberto = response;
              this.loading.stop();
              this.abrirRespostaSucesso(response);
              this.limparForm();
            }, (error) => {
              this.loading.stop();
              this.abrirRespostaErro(error);
            });
     }else{

      console.log(this.chamadoDadosMontado[0]);
      
          this.padraoService.abrirChamadoCadastroAcesso(JSON.stringify(this.chamadoDadosMontado[0]), anexos2).subscribe(response => {
            this.chamadoAberto = response;
            this.loading.stop();
            this.abrirRespostaSucesso(response);
            this.limparForm();
          }, (error) => {
            this.loading.stop();
            this.abrirRespostaErro(error);
          });
     }
  }
  }

  abrirRespostaSucesso(resposta: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { valor: resposta };
    dialogConfig.width = '600px';
    dialogConfig.height = '380px';
    dialogConfig.panelClass = 'custom-dialog';
    this.dialog.open(SuccessDialogComponent, dialogConfig);
  }

  abrirRespostaErro(resposta: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { valor: resposta };
    dialogConfig.width = '600px';
    dialogConfig.height = '380px';
    this.dialog.open(ErrorDialogComponent, dialogConfig);
  }

  abrirRespostaErroPadrao(resposta: any) {

    const dialogPadraoConfig = new MatDialogConfig();
    dialogPadraoConfig.autoFocus = true;
    dialogPadraoConfig.disableClose = true;
    dialogPadraoConfig.data = { valor: resposta };
    dialogPadraoConfig.width = '550px';
    dialogPadraoConfig.height = '350px';
    this.dialog.open(ErrorPadraoDialogComponent, dialogPadraoConfig);
  }


  abrirMensaagemdialog(resposta: any, titulo:any,subTitulo:any) {

    const mensagemDialog = new MatDialogConfig();
    mensagemDialog.autoFocus = true;
    mensagemDialog.disableClose = true;
    mensagemDialog.data = { valor: resposta, titulo: titulo,subTitulo:subTitulo };
    mensagemDialog.width = '550px';
    mensagemDialog.height = '400px';
    this.dialog.open(MensagemDialogComponent, mensagemDialog);
  }

  criarMaisUmCampoAnexo() {
    return this.formBuilder.group({
      anexo: ['']
    })
  }

  isValidarCpfSubstitutoEscrevente() : boolean {
    var count = 0;
    var isValid = true;
    this.nomeServicosSelected.forEach(id=>{
      this.nomeServicos.filter(element => {
        if (element.idSistemaTipoSolicitacao === id && element.sistema.idSistema === 1) {
          count++;
        }
      });
    });

    if((count === 2 || count > 2) && this.registerForm.get('numeroCpfSubstituto').value != null && this.registerForm.get('numeroCpfEscrevente').value != null){
      
      if(this.registerForm.get('numeroCpfSubstituto').value === this.registerForm.get('numeroCpfEscrevente').value ){
        this.abrirMensaagemdialog("O \"Escrevente/Substituto\" já foi inserido como \"Escrevente/Substituto\" no mesmo sistema.","Validação de Formulário","CPF");
        isValid = false;
      }
      
    }

    return isValid;

  }

  isValidarNomeSubstitutoEscrevente() : boolean {
    var count = 0;
    var isValid = true;
    this.nomeServicosSelected.forEach(id=>{
      this.nomeServicos.filter(element => {
        if (element.idSistemaTipoSolicitacao === id && element.sistema.idSistema === 1) {
          count++;
        }
      });
    });
    if((count === 2 || count > 2) && this.registerForm.get('nomeCompletoSubstituto').value != null && this.registerForm.get('nomeCompletoEscrevente').value != null){
      
      if(this.registerForm.get('nomeCompletoSubstituto').value === this.registerForm.get('nomeCompletoEscrevente').value ){
        this.abrirMensaagemdialog("O \"Escrevente/Substituto\" já foi inserido como \"Escrevente/Substituto\" no mesmo sistema.","Validação de Formulário","Nome do escrevente/substituto");
        isValid = false;
      }
      
    }

    return isValid;

  }

  isValidCampoSubstituto(): boolean {
    var obrigatorio = false;

        this.registerForm.get('emailSubstituto').valueChanges.subscribe(event => {
          this.registerForm.get('emailSubstituto').setValue(event.toLowerCase(), {emitEvent: false});
        });
        
        this.nomeServicosSelected.forEach(id=>{
          this.nomeServicos.forEach(element => {
            if ( element.idSistemaTipoSolicitacao === id && (element.tipoSolicitacao.descricao === "Cadastramento de substituto")) {
              obrigatorio = true;
            }
          });
        });  

        if(obrigatorio) {
          var nomeCompletoSubstituto = [Validators.required, Validators.minLength(4), Validators.maxLength(100)];
          var numeroCpfSubstituto = [Validators.required, Validators.minLength(5), Validators.maxLength(256), isValidCpf()];
          var emailSubstituto = [Validators.required,Validators.email,Validators.minLength(5), Validators.maxLength(256)];
          var numeroTelefoneSubstituto = [Validators.required, Validators.minLength(5), Validators.maxLength(256)];
          this.registerForm.controls['nomeCompletoSubstituto'].setValidators(nomeCompletoSubstituto);
          this.registerForm.controls['numeroCpfSubstituto'].setValidators(numeroCpfSubstituto);
          this.registerForm.controls['emailSubstituto'].setValidators(emailSubstituto);
          this.registerForm.controls['numeroTelefoneSubstituto'].setValidators(numeroTelefoneSubstituto);
        }else{
          var nomeCompletoSubstituto = [ Validators.minLength(4), Validators.maxLength(100)];
          var numeroCpfSubstituto = [ Validators.minLength(5), Validators.maxLength(256),isValidCpf()];
          var emailSubstituto = [Validators.minLength(5),Validators.email, Validators.maxLength(256)];
          var numeroTelefoneSubstituto = [Validators.minLength(5), Validators.maxLength(256)];
          this.registerForm.controls['nomeCompletoSubstituto'].setValidators(nomeCompletoSubstituto);
          this.registerForm.controls['numeroCpfSubstituto'].setValidators(numeroCpfSubstituto);
          this.registerForm.controls['emailSubstituto'].setValidators(emailSubstituto);
          this.registerForm.controls['numeroTelefoneSubstituto'].setValidators(numeroTelefoneSubstituto);
        }
        
        return obrigatorio;
  }


  isValidCampoEscrevente(): boolean {
    var obrigatorio = false;

        this.registerForm.get('emailEscrevente').valueChanges.subscribe(event => {
          this.registerForm.get('emailEscrevente').setValue(event.toLowerCase(), {emitEvent: false});
        });
        
        this.nomeServicosSelected.forEach(id=>{
          this.nomeServicos.forEach(element => {
            if ( element.idSistemaTipoSolicitacao === id && (element.tipoSolicitacao.descricao === "Cadastramento de escrevente")) {
              obrigatorio = true;
            }
          });
        });  

        if(obrigatorio) {
          var nomeCompletoEscrevente = [Validators.required, Validators.minLength(4), Validators.maxLength(100)];
          var numeroCpfEscrevente = [Validators.required, Validators.minLength(5), Validators.maxLength(256), isValidCpf()];
          var emailEscrevente = [Validators.required,Validators.email,Validators.minLength(5), Validators.maxLength(256)];
          var numeroTelefoneEscrevente = [Validators.required, Validators.minLength(5), Validators.maxLength(256)];
          this.registerForm.controls['nomeCompletoEscrevente'].setValidators(nomeCompletoEscrevente);
          this.registerForm.controls['numeroCpfEscrevente'].setValidators(numeroCpfEscrevente);
          this.registerForm.controls['emailEscrevente'].setValidators(emailEscrevente);
          this.registerForm.controls['numeroTelefoneEscrevente'].setValidators(numeroTelefoneEscrevente);
        }else{
          var nomeCompletoEscrevente = [ Validators.minLength(4), Validators.maxLength(100)];
          var numeroCpfEscrevente = [ Validators.minLength(5), Validators.maxLength(256),isValidCpf()];
          var emailEscrevente = [Validators.minLength(5),Validators.email, Validators.maxLength(256)];
          var numeroTelefoneEscrevente = [Validators.minLength(5), Validators.maxLength(256)];
          this.registerForm.controls['nomeCompletoEscrevente'].setValidators(nomeCompletoEscrevente);
          this.registerForm.controls['numeroCpfEscrevente'].setValidators(numeroCpfEscrevente);
          this.registerForm.controls['emailEscrevente'].setValidators(emailEscrevente);
          this.registerForm.controls['numeroTelefoneEscrevente'].setValidators(numeroTelefoneEscrevente);
        }
        
        return obrigatorio;
  }

  isValidBanco(): boolean {
    var valid = false;
    
    var obrigatorio:boolean = false;
    this.sistemasSelected.forEach(id => {
          this.nomeSistemas.filter(sistema => {
              if( sistema.idSistema === id && sistema.descricao === "Selo Digital" ) {
                valid = true;
              }
          });
    }); 

    return valid;
  }

  bancoObrigatorio(): boolean {
    var obrigatorio = false;
    
    this.listaSistemaDocumento.forEach(element => {
        if (element.documento.descricao == "Contas Bancárias de Arrecadação da Unidade Cartorária" && element.obrigatorio ===true ) {
          obrigatorio = true;
        }
    });
    return obrigatorio;
  }

  isNomeSistemasSCC() {
  
    var obrigatorio:boolean = false;
    this.sistemasSelected.forEach(id => {
          this.nomeSistemas.filter(sistema => {
              if( sistema.idSistema === id && sistema.descricao === "SCC" ) {
                obrigatorio = true;
              }
          });
    }); 

    if(obrigatorio) {
      var codigoCEI = [Validators.required];
      var codigoGerencia = [Validators.required];
      var codigoIBGE = [Validators.required];
      this.registerForm.controls['codigoCEI'].setValidators(codigoCEI);
      this.registerForm.controls['codigoGerencia'].setValidators(codigoGerencia);
      this.registerForm.controls['codigoIBGE'].setValidators(codigoIBGE);
    }else{
      this.registerForm.controls['codigoCEI'].setValidators(null);
      this.registerForm.controls['codigoGerencia'].setValidators(null);
      this.registerForm.controls['codigoIBGE'].setValidators(null);
    }
    return obrigatorio;
  }      

  isValidEnderecoServentia(): boolean {
    var valid = false;
    this.listaSistemaDocumento.forEach(element => {
        if (element.documento.descricao == "Contrato de Aluguel/Comprovante de Endereço da serventia") {
          valid = true;
        }
    });

    if(valid){
      this.registerForm.controls['cep'].setValidators(Validators.required); 
      this.registerForm.controls['logradouro'].setValidators(Validators.required);
      this.registerForm.controls['bairro'].setValidators(Validators.required);
      this.registerForm.controls['enderecoNumero'].setValidators(Validators.required);
      this.registerForm.controls['enderecoMunicipio'].setValidators(Validators.required);
      this.registerForm.controls['enderecoComarca'].setValidators(Validators.required);
    }else{
      this.registerForm.controls['cep'].setValidators(null);
      this.registerForm.controls['logradouro'].setValidators(null);
      this.registerForm.controls['bairro'].setValidators(null);
      this.registerForm.controls['enderecoNumero'].setValidators(null);
      this.registerForm.controls['enderecoMunicipio'].setValidators(null);
      this.registerForm.controls['enderecoComarca'].setValidators(null);
    }
    return valid;
  }

  isValidEnderecoSubstituto(): boolean {
    console.log('Entrou aqui');
    var valid = false;
    this.listaSistemaDocumento.forEach(element => {
        if (element.documento.descricao == "Comprovante de residência do substituto") {
          valid = true;
        }
    });

    if(valid){
      this.registerForm.controls['cepSubstituto'].setValidators(Validators.required); 
      this.registerForm.controls['logradouroSubstituto'].setValidators(Validators.required);
      this.registerForm.controls['bairroSubstituto'].setValidators(Validators.required);
      this.registerForm.controls['enderecoNumeroSubstituto'].setValidators(Validators.required);
      this.registerForm.controls['enderecoMunicipioSubstituto'].setValidators(Validators.required);
      this.registerForm.controls['enderecoComarcaSubstituto'].setValidators(Validators.required);
    }else{
      this.registerForm.controls['cepSubstituto'].setValidators(null);
      this.registerForm.controls['logradouroSubstituto'].setValidators(null);
      this.registerForm.controls['bairroSubstituto'].setValidators(null);
      this.registerForm.controls['enderecoNumeroSubstituto'].setValidators(null);
      this.registerForm.controls['enderecoMunicipioSubstituto'].setValidators(null);
      this.registerForm.controls['enderecoComarcaSubstituto'].setValidators(null);
    }
    return valid;
  }

  removeBanco(instituicao) {
    var index = this.listaBancos.indexOf(instituicao)
    if(this.listaBancos.length > 1) {

      if (index > -1) {
        this.listaBancos.splice(index, 1);
      }
      this.dataSource = new MatTableDataSource(this.listaBancos);
    }else{
      this.abrirMensaagemdialog("É necessário ter ao menos uma Conta Bancária cadastrada!","Validação de Formulário","Contas bancárias");
      return;
    }
  }

  adicionarBanco() {
    if (this.bancoForm.invalid) {
      this.abrirMensaagemdialog("Campo Banco, Agência e Conta são campos obrigatórios!","Validação de Formulário","Contas bancárias");
      return;
    }

    if(this.listaBancos.length > 2) {
      this.abrirMensaagemdialog("Só é permitido o cadastro de três contas bancarias!","Validação de Formulário","Contas bancárias");
      this.bancoForm = this.formBuilder.group({
        banco: ["", Validators.required],  
        agencia: ["", Validators.required],  
        conta: ["", [Validators.required]]  
      });
      return;
    }

    var bancoNaLista  = this.listaBancos.filter( banco=> (banco.banco == this.bancoForm.get('banco').value ));

    if(bancoNaLista.length > 0){
      this.abrirMensaagemdialog("Só é permitido o cadastro de uma conta bancária por Banco!","Validação de Formulário","Contas bancárias");
      return;
    }

    var instituicao : Banco = new Banco();
    instituicao.banco = this.bancoForm.get('banco').value;
    instituicao.agencia = this.bancoForm.get('agencia').value;
    instituicao.conta = this.bancoForm.get('conta').value;

    this.listaBancos.push(instituicao);

    this.dataSource = new MatTableDataSource(this.listaBancos);

    this.bancoForm = this.formBuilder.group({
      banco: ["", Validators.required],  
      agencia: ["", Validators.required],  
      conta: ["", [Validators.required]]
    });  
  }

  adicionarUmAnexo(descricao,obrigatorio,nomeArquivo) {
    this.count++;
    this.counter++;
    (this.anexoForm.get('anexoItem') as FormArray).push(this.formBuilder.group({ 
      anexo: ['',Validators.required]
    }))

    this.anexos.push(this.formBuilder.group({ anexo: ['',Validators.required]  , documentoNome: descricao, obrigatorio: obrigatorio,nomeArquivo:nomeArquivo}));

  }

  limparInput(index, arquivo: any, id) {

  this.element = document.getElementById(index) as HTMLElement;

   var element2 = document.getElementById('anexoInput'+ id) as HTMLInputElement;
   element2.disabled = false;

   var element3 = document.getElementById('valorAnexo'+id) as HTMLInputElement;
   element3.innerHTML = '';

    if(arquivo.files[0].size> 0 ){
      
      if(this.progressBar > 0) {
        this.progressBar -= (arquivo.files[0].size * 0.0000010) * 5;
      }
      
      this.tamanhoLido -= arquivo.files[0].size;
      this.map.delete(index);
    }
    
  }

  validarDocumentoObrigatorios(): boolean {
    var mensagem = [];
    var cont = 0
    var faltaDocumento = false;
    this.anexos.forEach(anexo => {
      var index = this.anexos.indexOf(anexo);

      var arquivo = this.map.get('divAnexo' + index);

      if(anexo.value.obrigatorio && !arquivo ) {
        mensagem[cont] = anexo.value.documentoNome;
        faltaDocumento = true
        cont++;
      } 
    });

    if(faltaDocumento){
      this.abrirMensaagemdialog("Falta anexar documento(s) Obrigatório(s)!","Validação de Formulário","Anexos");
    }
   
    return faltaDocumento;
  }

  removeInputAll() {

    this.listaSistemaDocumento = new Array<SistemaDocumento>();
    this. anexoForm= null;
    this.anexoForm = this.formBuilder.group({ anexoItem: [] });
    
    this.anexos.forEach(element => {
      var id = 'divAnexo'+this.anexos.indexOf(element);
      this.element = document.getElementById(id) as HTMLElement;
      this.element.hidden = true;
      this.map.delete(id);
    });
    this.anexos = [];
  }

  arrayInputs = [{ anexo: ['a', Validators.required] }, { anexo: 'b' }];

  formName = this.formBuilder.group({ controllerArray: this.formBuilder.array([]) })

  setArrayInputs(arrayInputs) {
    const arrayFG = arrayInputs.map(address => this.formBuilder.group(address));
    const formArray = this.formBuilder.array(arrayFG);
    this.anexoForm.setControl('anexoItem', formArray);
  }

  public removerEspaco(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.get(key).setValue(formGroup.get(key).value);
    });
  }

  removeInput(index, arquivo: any) {
    if (this.count == 0) {
      this.element = document.getElementById(index) as HTMLElement;
      this.element.hidden = true;
    }
    if (this.count > 0) {
      this.element = document.getElementById(index) as HTMLElement;
      this.element.hidden = true;
      this.count--;
    }
    if(this.progressBar > 0) {
      this.progressBar -= (arquivo.files[0].size * 0.0000010) * 5;
    }
    
    if(arquivo.files[0] !== undefined) {
      this.tamanhoLido -= arquivo.files[0].size;
    }   
    this.map.delete(index);
  }

}
